import React, { FC, useRef } from 'react'

import { useOutsideAlert } from '../../hooks'
import { Column } from '../column'
import { Row } from '../row'
import { ItemsList } from './items-list'
import { getListHeight } from './helpers'
import { DropdownItemsProps, PositionDropdown } from './dropdown-items.types'
import { useStyle } from './dropdown-items.styles'

export const SearchableDropdownItems: FC<DropdownItemsProps> = ({
  className,
  containerClassName,
  position = PositionDropdown.BOTTOM,
  data,
  active,
  disabled,
  children,
  open = false,
  isScrollable = false,
  onChange,
  onOpen
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const itemsRef = useRef<HTMLDivElement>(null)
  const itemsScrollRef = useRef<HTMLDivElement>(null)

  const width = ref.current ? ref.current.offsetWidth : 0
  const height = ref.current ? ref.current.offsetHeight : 0

  const listHeight = getListHeight({ data })
  const classes = useStyle({
    disabled,
    width,
    height,
    listHeight
  })

  const handleOnOpen = (state?: boolean) => () => {
    if (!disabled) {
      return
    }

    if (onOpen) {
      onOpen(Boolean(state))
    }
  }

  useOutsideAlert(itemsRef, open, handleOnOpen(false))
  const scrollableRef = isScrollable ? itemsScrollRef : null

  return (
    <Column
      fullWidth
      className={classes.container}
      justifyContent="flex-start"
      ref={itemsRef}
    >
      <Row fullWidth ref={ref}>
        {children}
      </Row>
      {open &&
        (!isScrollable ? (
          <ItemsList
            className={className}
            open={open}
            active={active}
            data={data}
            width={width}
            height={height}
            position={position}
            isScrollable={isScrollable}
            onChange={onChange}
            onOpen={handleOnOpen}
          />
        ) : (
          <Column
            fullWidth
            justifyContent="flex-start"
            ref={scrollableRef}
            className={`${containerClassName} ${classes.listContainer}`}
          >
            <ItemsList
              className={className}
              open={open}
              active={active}
              data={data}
              width={width}
              height={height}
              position={position}
              isScrollable={isScrollable}
              onChange={onChange}
              onOpen={handleOnOpen}
            />
          </Column>
        ))}
    </Column>
  )
}
